var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pdf-renderer__wrapper"},[_c('canvas',{ref:"canvas",staticClass:"pdf-renderer__canvas",staticStyle:{"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }